import { OrderCategory } from '@features/siteStatusV2/constants/order';
import { FtthOrder, Order } from '@features/siteStatusV2/types';

function isFtthOrder(order: Order | undefined): order is FtthOrder {
  return order?.category === OrderCategory.FTTH;
}

export default isFtthOrder;
